<template>
    <div>
        <div class="recommended-item__header">
            <div class="recommended-item__title-info">
                <h2 class="user-page recommended-item__title" v-html="title"></h2>
                <TotemButton v-if="buttonLabel" iconPosition="right" icon="arrow-right" color="secondary" size="small" @click="onButtonClick" :label="buttonLabel" />
            </div>
            <div class="recommended-item__description-info">
                <slot name="info" />
            </div>
        </div>
        <div class="recommended-item__content">
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            onButtonClick () {
                this.$emit('buttonClick')
            }
        },
        props: {
            title: {
                type: String,
                required: true
            },
            buttonLabel: String
        }
    }
</script>

<style lang="scss" scoped>
.recommended-item {
    &__header {
        display: flex;
        flex-direction: column;
        &.totem-button {
            margin-left: 30px;
        }

        [class*="mobile"] & {
            flex-direction: column;
            align-items: flex-start;
        }
    }

    &__title-info {
        display: flex;
        align-items: center;
        gap: 10px;

        [class*="mobile"] & {
            align-items: flex-end;
        }
    }

    &__title {
        font-family: PlusJakartaSans-Medium, sans-serif;
        font-size: 2.2rem;
    }

    &__content {
        margin: 20px 0 0;
    }
}
</style>
